module.exports = __webpack_public_path__ + "static/media/silverTop3D.68e85005.webp";